export default () => ({

    open: false,
    loaded: false,
    src: null, // our image source
    source: null, // the source of the picture: Photographer, Agency etc...
    
    positionRef: null,

    init(){

        this.positionRef = this.positionOverlay.bind(this);

    },

    positionOverlay(){

        let boundingRect = this.$refs.image.getBoundingClientRect();

        this.$refs.overlay.style.top = boundingRect.top + 'px';
        this.$refs.overlay.style.left = boundingRect.left + 'px';
        this.$refs.overlay.style.width = boundingRect.width + 'px';
        this.$refs.overlay.style.height = boundingRect.height + 'px';
    },

    imageLoad(){

        this.loaded = true;
        
        this.positionOverlay();

        window.addEventListener('resize', this.positionRef, false);

    },

    loadLightbox(src, source){
        this.open = true;
        this.source = source;
        this.src = src;
    },

    close() {
        
        window.removeEventListener('resize', this.positionRef, false);

        this.open = false;

        setTimeout(()=> {
            this.src = null;
            this.source = null;
            this.loaded = false;
        }, 300);

    }

    
});